/* eslint-disable no-param-reassign */
import axios from "axios";
import flatpickr from "flatpickr";
import { format, parseISO, isSameDay } from "date-fns";

import("flatpickr/dist/flatpickr.css");

export function loadMoreFilter(config, Alpine) {
  return {
    openFilterModal: false,
    apiEndPoint: config.apiEvent,
    isloaded: false,
    isFetching: false,
    filter: {
      search: "",
      noOfArticle: config.noOfArticle || 12,
      activePage: 0
    },
    filteredData: config.filters || [],
    defaultParams: config.defaultParams || [],
    disableEndDate: true,
    totalNoOfPages: 0,
    items: [],
    disableLoadMore: false,
    startDatepickerInstance: null,
    endDatepickerInstance: null,
    enableDateRangeFilter: config.enableDateRangeFilter || false,
    startDate: "",
    endDate: "",
    featuredCategories: config.featuredCategories || [],
    featureCategory: "all",
    featuredCategoryKey: config.featuredCategoryKey || "Categories",
    displayImage: config?.DisplayImage ?? true,

    init() {
      const vm = this;
      const el = vm.$el;

      // preselecting filters if pathname is present partial implementation.
      try {
        // create search params object
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.size > 0) {
          // loop through the search params
          searchParams.forEach((value, key) => {
            key = key.toLowerCase();
            let isInsideFeatured = false;
            // first check in featured categories as they are always of key category
            if (key === vm.featuredCategoryKey.toLowerCase()) {
              vm.featuredCategories.forEach((cat) => {
                if (cat.value === value) {
                  isInsideFeatured = true;
                }
              });
            }

            if (this.featureCategory !== value) {
              this.featureCategory = value;
            }

            vm.filteredData.forEach((filter) => {
              if (filter.id.toLowerCase() === vm.featuredCategoryKey.toLowerCase() && key === vm.featuredCategoryKey.toLowerCase() && isInsideFeatured) {
                if (filter.valueType === "multiple") {
                  filter.value.push(value);
                } else {
                  filter.value = value;
                }
                vm.featureCategory = value;
              } else if (filter.id.toLowerCase() === key) {
                filter.list.forEach((ft) => {
                  if (filter.valueType === "multiple") {
                    if (value.split(",").includes(ft.value)) {
                      filter.value.push(ft.value);
                    }
                  } else if (ft.value === value) {
                    filter.value = ft.value;
                  }
                });
              }
            });
          });
        }
      } catch (e) {
        console.error("Invalid Search Parameters");
      }

      vm.callApi();

      vm.$nextTick(() => {
        vm.setupDatepickers(el);
      });
    },

    setupDatepickers(el) {
      const vm = this;

      const startDate = el.querySelector(".start-date");
      const endDate = el.querySelector(".end-date");

      setTimeout(() => {
        if (startDate !== null) {
          vm.startDatepickerInstance = flatpickr(startDate, {
            onChange: function (selectedDates, dateStr, instance) {
              vm.disableEndDate = false;
              vm.updateEndDatepicker(dateStr, endDate);
            }
          });

          vm.endDatepickerInstance = flatpickr(endDate);
        }
      }, 200);
    },

    updateEndDatepicker(date, endDate) {
      const vm = this;

      vm.endDatepickerInstance = flatpickr(endDate, {
        minDate: date
      });

      vm.disableEndDate = false;
    },

    toggleFilterModal() {
      this.openFilterModal = !this.openFilterModal;
      if (this.openFilterModal) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    },

    LoadMore() {
      this.isFetching = true;
      setTimeout(() => {
        this.callApi();
      }, 500);
    },

    filterItems() {
      this.items = [];
      this.filter.activePage = 0;
      this.filter.search = "";
      this.isloaded = false;
      this.disableLoadMore = true;
      this.filteredData.forEach((item) => {
        if (item.id === this.featuredCategoryKey) {
          console.log(item.value.length > 0);
          if (item.value.length > 0) {
            if (this.featureCategory === "all") {
              this.featureCategory = "";
            }
          }
        }
      });
      setTimeout(() => {
        this.callApi();
      }, 500);
      this.openFilterModal = false;
      document.body.classList.remove("overflow-hidden");
    },

    searchApi(e) {
      e.preventDefault();
      this.isloaded = false;
      this.disableLoadMore = true;
      this.clearFilter();
      this.featureCategory = "all";
      const input = e.target.closest("form").querySelector('input[type="search"]');
      input.blur();
    },

    clearSearch(e) {
      this.filter.search = "";
      this.searchApi(e);
    },
    clear() {
      this.items = [];
      this.filter.activePage = 0;

      this.filteredData.forEach((filterItem) => {
        if (filterItem.valueType === "single") {
          filterItem.value = "";
        } else if (filterItem.valueType === "multiple") {
          filterItem.value = [];
          if (filterItem.id === this.featuredCategoryKey) {
            if (this.featureCategory !== "") {
              filterItem.value.push(this.featureCategory);
            }
          }
        } else {
          filterItem.value = "";
        }
      });

      this.startDate = "";
      this.endDate = "";
    },

    clearFilter() {
      this.clear();
      setTimeout(() => {
        this.callApi();
      }, 500);
    },

    changeArticleNo(e) {
      const { target } = e;
      const targetWrapper = target.closest(".js-items-per-page").querySelectorAll("li");
      const { value } = target.dataset;
      this.items = [];
      if (value !== this.filter.noOfArticle) {
        this.filter.activePage = 0;
        targetWrapper.forEach((item) => {
          const button = item.querySelector(".js-button");
          if (button === target) {
            button.classList.add("js-button-active");
          } else if (button.classList.contains("js-button-active")) {
            button.classList.remove("js-button-active");
          }
        });
        this.filter.noOfArticle = value;
        this.isloaded = false;
        this.disableLoadMore = true;
        setTimeout(() => {
          this.callApi();
        }, 500);
      }
    },

    changeCategory() {
      this.items = [];
      this.filter.search = "";
      this.isloaded = false;
      this.disableLoadMore = true;
      this.filter.activePage = 0;
      setTimeout(() => {
        this.callApi();
      }, 500);
    },

    filterCategory() {
      this.items = [];
      this.filter.activePage = 0;
      this.startDate = "";
      this.endDate = "";
      this.filteredData.forEach((item) => {
        if (item.id === this.featuredCategoryKey) {
          if (item.valueType === "single") {
            item.value = this.featureCategory;
          } else if (item.valueType === "multiple") {
            if (this.featuredCategories.length > 0) {
              this.featuredCategories.forEach((featureCategory) => {
                item.value = item.value.filter((a) => a !== featureCategory.value);
              });
            }

            if (this.featureCategory === "all") {
              item.value = [];
            } else {
              item.value.push(this.featureCategory);
            }
          }
        }
      });

      this.items = [];
      this.filter.activePage = 0;
      this.filter.search = "";
      this.isloaded = false;
      this.disableLoadMore = true;

      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.size > 0) {
        searchParams.forEach((searchValue, key) => {
          if (key === "Categories") {
            if (this.featureCategory !== searchValue) {
              console.log("searchValue", searchValue);
              console.log("featureCategory", this.featureCategory);
            }
          }
        });
      }
      setTimeout(() => {
        this.callApi();
      }, 500);
    },

    // Formats card dates to display single-day as "dd MMM yyyy" or multi-day as "dd MMM - dd MMM yyyy"
    formatDisplayDate(startDateString, endDateString) {
      if (!startDateString) return "";

      try {
        const startDate = parseISO(startDateString);
        const endDate = endDateString ? parseISO(endDateString) : null;

        if (!endDate || isSameDay(startDate, endDate)) {
          return format(startDate, "dd MMM yyyy");
        }
        return `${format(startDate, "dd MMM")} - ${format(endDate, "dd MMM yyyy")}`;
      } catch (error) {
        console.error("Invalid date format in range:", { startDateString, endDateString });
        return "";
      }
    },

    async callApi() {
      this.filter.activePage += 1;

      const data = {
        search: this.filter.search,
        itemsPerPage: this.filter.noOfArticle,
        pageNumber: this.filter.activePage
      };

      if (this.filteredData.length > 0) {
        this.filteredData.forEach((filterItem) => {
          let finalValue = "";
          if (filterItem.valueType === "single") {
            if (filterItem.value.toLowerCase() === "all") {
              finalValue = "";
            } else {
              finalValue = filterItem.value;
            }
            data[`${filterItem.id}`] = finalValue;
          } else if (filterItem.valueType === "multiple") {
            if (filterItem?.value?.length === 1) {
              if (filterItem.value[0].toLowerCase() === "all") {
                finalValue = null;
              } else {
                // eslint-disable-next-line prefer-destructuring
                finalValue = filterItem.value[0];
              }
              data[`${filterItem.id}`] = finalValue;
            } else if (filterItem?.value?.length > 1) {
              // eslint-disable-next-line no-shadow
              filterItem.value.forEach((filterItem, index) => {
                if (index === 0) {
                  finalValue = filterItem;
                } else {
                  finalValue += `,${filterItem}`;
                }
              });
              data[`${filterItem.id}`] = finalValue;
            } else if (filterItem.id === this.featuredCategoryKey) {
              if (this.featureCategory !== "all") {
                data[`${filterItem.id}`] = this.featureCategory;
              } else {
                data[`${filterItem.id}`] = null;
              }
            } else {
              data[`${filterItem.id}`] = null;
            }
          } else {
            finalValue = null;
            data[`${filterItem.id}`] = finalValue;
          }
        });
      }

      // if (this.featuredCategories.length > 0) {
      //   console.log(this.filteredData.find((a) => a.id === this.featuredCategoryKey));
      //   if (this.filteredData.find((a) => a.id === this.featuredCategoryKey) === undefined) {
      //     data.Categories = this.featureCategory;
      //   }
      // }

      if (this.defaultParams.length > 0) {
        this.defaultParams.forEach((param) => {
          data[`${param.id}`] = param.value;
        });
      }

      if (this.enableDateRangeFilter) {
        data.startDate = this.startDate;
        data.endDate = this.endDate;
      }

      axios
        .post(`${this.apiEndPoint}`, { ...data })
        .then((response) => {
          // handle success
          this.items = [...this.items, ...response.data.cards];
          this.totalNoOfPages = response.data.pageCount;
          this.disableLoadMore = this.filter.activePage >= this.totalNoOfPages;
          this.isloaded = true;
          this.isFetching = false;
        })
        .catch((error) => {
          // handle error
          console.log(error);
        });
    }
  };
}
